import { Id } from '@nextforce/api'

const keys = {
  all: ['rating'],
  list: (storeId: Id) => [...keys.all, storeId],
}

export default keys
